/**
 * InvitePage.tsx — waitlist signup page
 *
 * Purpose:    Capture email for ɳSentry early-access waitlist
 * Inputs:     WaitlistForm component (client-side state machine)
 * Outputs:    Waitlist signup page with referral link on success
 * Constraints: Client-side only; no SSR
 * SOT:        T-P3-E3-W2-S5-T01
 */
import { Link } from 'react-router-dom'
import { WaitlistForm } from '../components/InvitePage/WaitlistForm'

export function InvitePage() {
  return (
    <section className="mx-auto max-w-md px-4 py-20 sm:px-6">
      <div className="mb-8 text-center">
        <h1 className="mb-3 text-3xl font-bold">Join the waitlist</h1>
        <p className="text-brand-muted">
          ɳSentry ships in v1.1.0 and is invite-only at launch. Sign up below and you will get
          a code when it ships plus a referral link to bring your team along.
        </p>
      </div>

      <div className="rounded-xl border border-brand-subtle bg-brand-surface/50 p-8">
        <WaitlistForm />
      </div>

      <p className="mt-8 text-center text-sm text-brand-muted">
        Already have an invite code?{' '}
        <Link to="/invite/code" className="text-indigo-700 dark:text-indigo-400 hover:text-indigo-700 dark:text-indigo-300 transition-colors">
          Redeem it here
        </Link>
      </p>
    </section>
  )
}
